<template>
    <div>
        <v-row>
            <v-card
                    class="summary-bck fullInfoInner"
                    width="880"
            >

                <v-card-text>
                    <div class="scroll">

                        <div class="summary-heading mt-1 ">Aptitude Test Scores
                            <div class="image" >
                                <v-img src="../../../../../../assets/svg/TestScore.svg"></v-img>
                                <h2 class="test-wrap ">
                                           <span class="test-score test-text">{{this.score}}/{{this.noOfQuestionServed}}</span>
                                 </h2>
                            </div>

                        </div>
                        <div  v-if="userTest === ''">
                            <h2 class="no-data">No Test Data Available Yet</h2>
                        </div>

                        <v-row  v-for="test in userTest" :key="test._id">
                                <v-col cols="6">
                                    <p class="question-info d-inline-block">Question {{test.id}}</p> <small class="text-danger" v-if="response[test.id] === ''">Unanswered</small>
                                    <p class="question-label">{{test.question}}</p>

                                    <div v-for="testOption in test.options" :key="testOption._id" class="d-flex" >
                                        <div v-if="testOption === test.answer" class="">

                                            <v-img src="../../../../../../assets/greenbutton.svg" class="check-icon ml-1 mr-3"></v-img>
                                        </div>
                                        <div v-else-if="response[test.id] !== testOption">
                                            <v-img src="../../../../../../assets/options.svg" class="check-icon ml-1 mr-3 "></v-img>

                                        </div>
                                        <div v-else>
                                            <v-img src="../../../../../../assets/redbutton.svg" class="check-icon ml-1  mr-3"></v-img>

                                        </div>

                                        <span class="mr-3" :style="[testOption === test.answer ? {color: 'green'} : {color: 'black'} && response[test.id] !== testOption ? {color: 'black'} : {color: 'red'}]">{{testOption}}</span>

                                    </div>

                                </v-col>
                                <v-col cols="6" v-if="test.image!== 'no image'">
                                    <img  :src="require('@/assets'+test.image)" alt="image" width="90%" class="mt-4"/>
                                </v-col>
                        </v-row>
                    </div>
                </v-card-text>
            </v-card>
        </v-row>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "TestInfo",
        data(){
            return{
                userTest:'',
                testOptions:'',
                noOfQuestionServed:'',
                score:'',
                response: {}
            }
        },
        computed: mapGetters([
              'applicant'
        ])  ,
        created() {
            this.userTest = this.$store.getters.applicant.applicantDocument.aptitudeTest.testObj.userTest
            this.response = this.$store.getters.applicant.applicantDocument.aptitudeTest.testObj.response
            let applicantHasNotTakenTest= this.userTest=== ''
            this.noOfQuestionServed = this.userTest.length
            this.score = this.$store.getters.applicant.applicantDocument.aptitudeTest.score
          if(applicantHasNotTakenTest){
            this.score = "N"
            this.noOfQuestionServed = "A"
          }

        }

    }
</script>

<style scoped>
    .question-info{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 21px;

        /* identical to box height */
        display: flex;
        align-items: center;
        letter-spacing: 0.05em;

        color: #00A998;
    }
    .question-label{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: 300;
        font-size: 15px;
        line-height: 21px;

        color: #000000;
    }
    .summary-bck{
        background: #FFF2C7;
        border-radius: 16px;
    }
    .summary-heading{
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: bold;
        font-size: 21px;
        line-height: 27px;
        display: flex;
        align-items: center;
        letter-spacing: -0.02em;
        color: #960C0C;
        /*position: sticky !important;*/
        /*position: -webkit-sticky;*/
        /*top:10px*/

    }
    p{
        margin-bottom: 7px !important;
    }
    /*.fullInfoInner {*/
    /*    width: 100%;*/
    /*    overflow-y: scroll;*/
    /*    overflow-x: hidden;*/
    /*    max-height: 430px;*/
    /*    height: 430px;*/
    /*    !*margin-top: 20px;*!*/
    /*}*/
    .scroll{
        overflow-y: scroll;
        max-height: 430px;
        height: 430px;
        overflow-x: hidden;
        margin-right: 40px;
        width: 100%;
    }
    .image{
        position: relative;
        width: 100px;
        margin-left: 50%;
        height: 100px;
    }
    .test-wrap {
        height: 98px;
        position: absolute;
        width: 98px;
        margin-top: -90px;
        margin-left: 11px;
    }

    .test-score{
        background: radial-gradient(
                ellipse at center,
                #960C0C 0%,
                #960C0C 70%,
                #960C0C 70.3%
        );
        height: 80%;
        width: 80%;
        color: white;
        position: absolute;
        margin: 0;
        border-radius: 50% !important;
    }

    .test-text{
        text-align: center !important;
        padding-top: 25px !important;
        font-size: 21px !important;
        font-weight: bold !important;

    }
    .no-data{
        text-align: center !important;
        margin-top: 90px !important;
        color: #960C0C;
    }
    .check-icon{
        /*max-width: 7% !important;*/
        /*width: 7% !important;*/
        color: green !important;
    }

    </style>